import { Component, h, Prop, Host } from "@stencil/core";
import { NavigationTriggerProps } from "./f-navigation-trigger-model";

@Component({
  tag: "f-navigation-trigger",
  styleUrl: "f-navigation-trigger.scss",
  shadow: true,
})
export class NavigationTrigger {
  @Prop() toggleMenu: NavigationTriggerProps["toggleMenu"];
  @Prop() hiddenLabel: NavigationTriggerProps["hiddenLabel"] = "menu";
  @Prop({ mutable: true })
  isMobileMenuOpen: NavigationTriggerProps["isMobileMenuOpen"];

  render() {
    return (
      <Host
        class={{
          "is-active": this.isMobileMenuOpen,
        }}
      >
        <button
          type="button"
          class={{
            "f-main-navigation-trigger": true,
            "is-active": this.isMobileMenuOpen,
          }}
          aria-haspopup="true"
          aria-expanded={this.isMobileMenuOpen}
          onClick={() => {
            this.toggleMenu();
          }}
          data-test="f-navigation-trigger"
        >
          <span class="f-main-navigation-trigger__icon">
            <span class="f-main-navigation-trigger__icon-bar" />
            <span class="f-main-navigation-trigger__icon-bar" />
            <span class="f-main-navigation-trigger__icon-bar" />
            <span class="f-main-navigation-trigger__icon-bar" />
          </span>
          <f-visually-hidden>{this.hiddenLabel}</f-visually-hidden>
        </button>
      </Host>
    );
  }
}
